import stores from '../../models/Stores';
import { ProjectDataObject } from 'cd-eft/models/Projects/projectsLibrary';
import DelineateWatershedGpApi from 'cd-eft/services/DelineateWatershedGpApi/DelineateWatershedGpApi';
import { IAddSessionResourcePost, IAddSessionResourceResponse } from 'cd-eft/models/Projects/sessionResources';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';

const AppStore = stores.AppStore;
const watershedApi = new DelineateWatershedGpApi();

export async function createGpSessionForProject(project: ProjectDataObject): Promise<void> {
  const gpSessionId = await watershedApi.createGpSession();
  if (!gpSessionId && (project.projectClassId == 1)) {
    throw new Error('Failed to create a GP session for the project.');
  }

  if (project.projectClassId == 4 /* "analysis-hydrology" */) {
    AppStore.efh2Store.projectsStore.currentGpSessionId = gpSessionId;
    AppStore.efh2Store.projectsStore.currentProjectId = project.projectUuid;
    if (project.sessionList[0]) {
      AppStore.efh2Store.projectsStore.currentSessionId = project.sessionList[0].sessionUuid;
    } else {
      AppStore.efh2Store.projectsStore.currentSessionId = '';
    }
  } else if (project.projectClassId == 1 /* "design" */) {
    AppStore.designStore.projectsStore.currentGpSessionId = gpSessionId;
    AppStore.designStore.projectsStore.currentProjectId = project.projectUuid;
    if (project.sessionList[0]) {
      AppStore.designStore.projectsStore.currentSessionId = project.sessionList[0].sessionUuid;
    } else {
      AppStore.designStore.projectsStore.currentSessionId = '';
    }
  } else {
    throw new Error('Unexpected projectClassId. Not implemented.');
  }

  if (project.sessionList[0].sessionUuid) {
    try {
      const postJSON: IAddSessionResourcePost = {
        currentUser: localStorage['username'],
        sessionResources: [
          {
            sessionResourceTypeId: 1, // should not be 0 -- breaks on back end
            sessionResourceValue: gpSessionId,
          },
        ],
        sessionUuid: project.sessionList[0].sessionUuid,
      };

      await PRJAPI.EftSessionController.addSessionResourceUsingPOST(postJSON);
      //
    } catch (error) {
      console.error('createGpSessionForProject: error =', error);
    }
  } else {
    throw new Error('Unexpected result: project.session object does not exist.');
  }
}
